module.exports = __webpack_public_path__ + "img/PlayStoreQR.b3d14e74.svg";